import { ModuleWithProviders } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { BaseComponent } from '../../components';
import { ResetPasswordComponent } from '../../components/reset-password/reset-password.component';
import { LoggedInGuard } from '../../services';

const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home/jobs'
  },
  {
    path: 'login',
    loadChildren: () => import('../modules/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    component: BaseComponent,
    children: [
      {
        path: 'home',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('../modules/home.module').then(m => m.HomeModule)
      }
    ]
  },
  {
    path: 'passwordreset',
    component: ResetPasswordComponent
  },
  {
    path: '**',
    redirectTo: '/home/jobs'
  }
];

export const AppRouting: ModuleWithProviders<any> = RouterModule
  .forRoot(appRoutes, {
    preloadingStrategy: PreloadAllModules
  });
